import React from 'react';
import './IndustryTools.css';
// --- MANUAL IMPORTS (Please ensure all these files exist in src/pages/AiMasterclass/assets) ---

// 🎨 Image Generation
import nanoBanana from '../assets/nanoBanana.png';
import dalle from '../assets/dalle.png';
import adobeFirefly from '../assets/Adobe Firefly.png';
import canva from '../assets/canva.png';
import stableDiffusion from '../assets/stablefusion.png';
import leonardoAi from '../assets/leonardoAi.jpg';
import openArt from '../assets/openArt.avif';
import unsplash from '../assets/unsplash.png';

// 🎥 Video Generation
import veo3 from '../assets/veo3.png';
import klingAi from '../assets/klingAi.png';
import lumaAi from '../assets/lumaAi.png';
import runwayGen4 from '../assets/runwayGen4.png';
import hailuoAi from '../assets/hailuoAi.webp';
import polloAi from '../assets/polloAi.png';
import invideoAi from '../assets/invideoAi.webp';

// 🎙️ Audio / Voice
import suno from '../assets/suno.jpg';
import udio from '../assets/udio.avif';
import aiva from '../assets/aiva.png';
import elevenLabs from '../assets/elevenLabs.svg';
import boomy from '../assets/boomy.jpg';
import soundraw from '../assets/soundraw.jpg';

// 🔗 Calling Tools
import bolna from '../assets/bolna.png';
import wisprFlow from '../assets/wisprFlow.png';
import vapi from '../assets/vapi.webp';
import ringgAi from '../assets/ringgAi.jpg';

// ⚙️ Workflow Automation
import make from '../assets/make.jpg';
import zapier from '../assets/Zapier.jpg';
import n8n from '../assets/n8n.png';
import gumloop from '../assets/gumloop.png';
import pipedream from '../assets/pipedream.jpg';
import huggingFace from '../assets/huggingFace.png';
import openClaw from '../assets/openClaw.jpg';

// 🎨 UI/UX
import stitch from '../assets/stitch.png';
import figma from '../assets/figma.png';
import framerAi from '../assets/framerAi.jpeg';
import maze from '../assets/maze.webp';
import adobeXd from '../assets/adobeXd.png';
import visily from '../assets/visily.avif';

// 📊 Productivity
import notion from '../assets/notion.webp';
import asana from '../assets/asana.png';
import clickup from '../assets/clickup.jpg';
import monday from '../assets/monday.png';
import notebookLm from '../assets/notebookLm.jpg';
import gammaAi from '../assets/gammaAi.png';
import beautifulAi from '../assets/beautifulAi.jpg';
import otterAi from '../assets/otterAi.jpg';
import motionAi from '../assets/motionAi.jpg';
import napkin from '../assets/napkin.png';
import enhancv from '../assets/enhancv.png';
import presentationAi from '../assets/presentationAi.png';

// 🧩 No Code
import bubble from '../assets/bubble.jpg';
import flutterFlow from '../assets/flutterFlow.png';
import webflow from '../assets/webflow.webp';
import weweb from '../assets/weweb.jpg';

// 💻 Vibe Coding
import v0 from '../assets/v0.png';
import wix from '../assets/wix.jpg';
import caffeineAi from '../assets/caffeineAi.jpg';
import lovable from '../assets/lovable.jpg';
import replit from '../assets/replit.png';
import emergentAi from '../assets/emergentAi.jpg';
import googleAiStudio from '../assets/googleAiStudio.jpg';

// 🧠 Smart IDE
import antigravity from '../assets/antigravity.jpg';
import cursor from '../assets/cursor.jpg';
import kiro from '../assets/kiro.svg';
import windsurf from '../assets/windsurf.png';
import vsCode from '../assets/vsCode.png';

// 🔌 Plugins
import codex from '../assets/codex.png';
import githubCopilot from '../assets/githubCopilot.png';
import claudeCode from '../assets/claudeCode.png';
import revisions from '../assets/revisions.jpg';
import aider from '../assets/aider.png';

// 🧠 Large Language Models
import gemini from '../assets/gemini.jpg';
import chatgpt from '../assets/dalle.png';
import grok from '../assets/grok.png';
import claude from '../assets/claude-ai-icon.webp';
import perflexity from '../assets/perflexity.png';

import promptcowboy from '../assets/promptcowboy.png';
import ehancer from "../assets/dalle.png"
import quillbot from "../assets/quillbot.png"

const getPlaceholder = (name) => `https://ui-avatars.com/api/?name=${encodeURIComponent(name)}&background=2A2A35&color=9b87f5&size=64&font-size=0.4&rounded=true`;



const categories = [
  {
    title: "🧠 Large Language Models",
    tools: [
      { name: "Gemini", logo: gemini },
      { name: "ChatGPT", logo: chatgpt },
      { name: "Grok", logo: grok },
      { name: "Perplexity", logo: perflexity },
      { name: "Claude", logo: claude }
    ]
  },
  {
    title: "🧠 Smart IDE",
    tools: [
      { name: "Antigravity", logo: antigravity },
      { name: "Cursor", logo: cursor },
      { name: "Kiro", logo: kiro },
      { name: "Windsurf", logo: windsurf },
      { name: "VS Code", logo: vsCode }
    ]
  },
  {
    title: "🔌 Plugins",
    tools: [
      { name: "Codex", logo: codex },
      { name: "GitHub Copilot", logo: githubCopilot },
      { name: "Claude Code", logo: claudeCode },
      { name: "Revisions", logo: revisions },
      { name: "Aider", logo: aider }
    ]
  },
  {
    title: "💻 Vibe Coding",
    tools: [
      { name: "v0", logo: v0 },
      { name: "Wix", logo: wix },
      { name: "Caffeine AI", logo: caffeineAi },
      { name: "Lovable", logo: lovable },
      { name: "Replit", logo: replit },
      { name: "Emergent AI", logo: emergentAi },
      { name: "Google AI Studio", logo: googleAiStudio }
    ]
  },
  {
    title: "⚙️ Workflow Automation",
    tools: [
      { name: "Make", logo: make },
      { name: "Zapier", logo: zapier },
      { name: "n8n", logo: n8n },
      { name: "Gumloop", logo: gumloop },
      { name: "Pipedream", logo: pipedream },
      { name: "Hugging Face", logo: huggingFace },
      { name: "OpenClaw", logo: openClaw }
    ]
  },
  {
    title: "📝 Prompt Engineering",
    tools: [
      { name: "prompt cowboy", logo: promptcowboy },
      { name: "Openai prompt enhancer", logo: ehancer },
      { name: "Quillbot", logo: quillbot }
    ]
  },
  {
    title: "🤖 ML Ops",
    tools: [
      { name: "MLflow", logo: getPlaceholder("MLflow") },
      { name: "Weights & Biases", logo: getPlaceholder("W&B") }
    ]
  },

  {
    title: "🧩 No Code",
    tools: [
      { name: "Bubble", logo: bubble },
      { name: "FlutterFlow", logo: flutterFlow },
      { name: "Webflow", logo: webflow },
      { name: "WeWeb", logo: weweb }
    ]
  },
  {
    title: "📊 Productivity",
    tools: [
      { name: "Notion", logo: notion },
      { name: "Asana", logo: asana },
      { name: "PresentationAi", logo: presentationAi },
      { name: "ClickUp", logo: clickup },
      { name: "Monday.com", logo: monday },
      { name: "NotebookLM", logo: notebookLm },
      { name: "Gamma AI", logo: gammaAi },
      { name: "Beautiful.ai", logo: beautifulAi },
      { name: "Otter AI", logo: otterAi },
      { name: "Motion AI", logo: motionAi },
      { name: "Napkin", logo: napkin },
      { name: "Enhancv", logo: enhancv }
    ]
  },
  {
    title: "🎨 UI/UX",
    tools: [
      { name: "Stitch", logo: stitch },
      { name: "Figma", logo: figma },
      { name: "Framer AI", logo: framerAi },
      { name: "Maze", logo: maze },
      { name: "Adobe XD", logo: adobeXd },
      { name: "Canva", logo: canva },
      { name: "Visily", logo: visily }
    ]
  },
  {
    title: "🎨 Image Generation",
    tools: [
      { name: "Nano Banana", logo: nanoBanana },
      { name: "DALL·E", logo: dalle },
      { name: "Canva", logo: canva },
      { name: "Adobe Firefly", logo: adobeFirefly },
      { name: "Stable Diffusion", logo: stableDiffusion },
      { name: "Leonardo AI", logo: leonardoAi },
      { name: "OpenArt", logo: openArt },
      { name: "Unsplash", logo: unsplash }
    ]
  },
  {
    title: "🎥 Video Generation",
    tools: [
      { name: "Veo 3", logo: veo3 },
      { name: "Kling AI", logo: klingAi },
      { name: "Luma AI", logo: lumaAi },
      { name: "Runway Gen-4", logo: runwayGen4 },
      { name: "Hailuo AI", logo: hailuoAi },
      { name: "Pollo AI", logo: polloAi },
      { name: "InVideo AI", logo: invideoAi }
    ]
  },
  {
    title: "🎙️ Audio / Voice",
    tools: [
      { name: "Suno", logo: suno },
      { name: "Udio", logo: udio },
      { name: "AIVA", logo: aiva },
      { name: "ElevenLabs", logo: elevenLabs },
      { name: "Boomy", logo: boomy },
      { name: "Soundraw", logo: soundraw }
    ]
  },
  {
    title: "🔗 Calling Tools",
    tools: [
      { name: "Bolna", logo: bolna },
      { name: "WisprFlow", logo: wisprFlow },
      { name: "Vapi", logo: vapi },
      { name: "Ringg AI", logo: ringgAi }
    ]
  }
];

const IndustryTools = () => {
  return (
    <section className="mc-section mc-tools-section">
      <h2 className="mc-section-title mc-gradient-accent">Industry-Leading Tools</h2>
      <div className="mc-categories-grid">
        {categories.map((category, idx) => {
          const visibleTools = category.tools.slice(0, 3);
          const hiddenCount = category.tools.length - 3;

          return (
            <div key={idx} className="mc-category-card">
              <h3 className="mc-category-title">{category.title}</h3>

              <div className="mc-tools-list">
                {visibleTools.map((tool, i) => (
                  <div key={i} className="mc-tool-item">
                    <img
                      src={tool.logo}
                      alt={tool.name}
                      className="mc-tool-logo"
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = getPlaceholder(tool.name);
                      }}
                    />
                    <span className="mc-tool-name">{tool.name}</span>
                  </div>
                ))}

                {hiddenCount > 0 && (
                  <div className="mc-tool-item mc-tool-more-item">
                    <div className="mc-tool-more-circle">
                      +{hiddenCount}
                    </div>
                    <span className="mc-tool-name">Tools</span>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default IndustryTools;
